"use strict";
/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
Object.defineProperty(exports, "__esModule", { value: true });
exports.XIcon32Regular = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var forwardRef_1 = require("../../helpers/forwardRef");
var BaseIcon_1 = require("../../internal/BaseIcon");
exports.XIcon32Regular = forwardRef_1.forwardRef('XIcon32Regular', function (props, ref) {
    return (react_1.default.createElement(BaseIcon_1.BaseIcon, tslib_1.__assign({ ref: ref, viewBoxSize: 32 }, props),
        react_1.default.createElement("path", { d: "M5.747 5.747a1 1 0 0 1 1.414 0L16 14.586l8.84-8.84a1 1 0 1 1 1.413 1.415L17.414 16l8.84 8.84a1 1 0 0 1-1.415 1.413L16 17.414l-8.84 8.84a1 1 0 0 1-1.413-1.415L14.586 16l-8.84-8.84a1 1 0 0 1 0-1.413Z" })));
});
